<template>
  <div>
    <div class="flex border-b border-black-0.1">
      <div class="w-full">
        <label
          class="block w-full label pl-2.5 pb-2.5 pt-5 border-b leading-6 border-black-0.1"
          for="dates-select"
        >Available dates below for small open group departures – please enquire directly if you are interested in a bespoke adventure:</label
        >
        <div v-if="!adventureIsEnquireOnly" class="select-wrapper relative w-full text-blue-dark">
          <select
            name="dates"
            id="dates-select"
            class="h-15 w-full pl-5 pr-10 font-primary font-extrabold text-blue-dark text-16 tracking-1/4"
            :class="backgroundColor"
            v-model="selectedDepartureId"
            @change="onDepartureChange"
            :disabled="loading"
          >
            <option :value="null">Select Dates</option>
            <option v-for="(item, index) in availableDepartures" :key="index" :value="item.uuid">
              {{ formatDates(item.start_date, item.end_date) }}
            </option>
          </select>
        </div>
        <p
          v-else
          class="w-full h-15 pl-5 bg-whiter uppercase font-extrabold text-blue-brand text-16 tracking-1/4 flex items-center "
        >
          Please enquire
        </p>
      </div>
    </div>

    <div v-if="selectedDeparture" class="bg-grey-lightest">
      <div
        ref="adventuresButton"
        class="expand-button relative h-12.5 flex items-center cursor-pointer"
        @click.prevent="toggleAdventureList"
      >
        <p class="label pl-2.5">Adventure</p>
        <div class="absolute top-0 right-0 h-12.5 w-12.5 flex items-center justify-center">
          <span class="triangle triangle-md expand-triangle"></span>
        </div>
      </div>

      <div ref="adventuresList" class="expand-list">
        <div class="border-b border-black-0.1 py-4">
          <div class="flex items-center pl-2">
            <input
              type="number"
              name="people"
              id="people-input"
              class="h-15 w-15 shadow-right text-center bg-white font-primary font-extrabold text-blue-brand text-16 uppercase tracking-1/4"
              min="1"
              :value="peopleCount"
              @input="onChangePeopleCount"
            />
            <div>
              <label
                class="font-primary font-extrabold text-blue-brand text-14 tracking-1/4 pl-2.5"
                for="people-input"
              >{{ selectedAdventure.name }}</label
              >
              <p class="font-primary font-normal text-blue-brand text-14 tracking-1/4 pl-2.5">
                {{ adventureDateString }}
              </p>
            </div>
          </div>

          <div class="flex items-center justify-between pl-2.5 pr-5 pt-2.5">
            <p class="text-center font-primary font-normal text-blue-dark text-20 leading-1 pr-10">
              <display-price
                :price-gbp="selectedDeparture.price_gbp"
                :price-usd="selectedDeparture.price_usd"
              ></display-price>
            </p>
            <hr class="h-0.5 w-full bg-grey-lighter" />
            <p
              class="text-center font-primary font-extrabold text-blue-dark text-20 leading-1 pl-10"
            >
              <display-price
                :price-gbp="selectedDeparture.price_gbp * peopleCount"
                :price-usd="selectedDeparture.price_usd * peopleCount"
              ></display-price>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-show="selectedDepartureId">
      <div v-show="allExtras.length > 0" class="bg-grey-lightest">
        <div
          ref="extrasButton"
          class="expand-button relative h-12.5 flex items-center cursor-pointer"
          @click.prevent="toggleExtrasList"
        >
          <p class="label pl-2.5">Optional Extras for your adventure</p>
          <div class="absolute top-0 right-0 h-12.5 w-12.5 flex items-center justify-center">
            <span class="triangle triangle-md expand-triangle"></span>
          </div>
        </div>
        <div ref="extrasList" class="expand-list">
          <template v-for="(extra, index) in allExtras">
            <enquiry-booking-extra :extra="extra" :key="index"></enquiry-booking-extra>
          </template>
        </div>
      </div>
      <div v-show="departureAddons.length > 0" class="bg-grey-lightest border-b border-black-0.1">
        <div
          ref="addonsButton"
          class="expand-button relative h-12.5 flex items-center cursor-pointer"
          @click.prevent="toggleAddonsList"
        >
          <p class="label pl-2.5">Add on Adventures</p>
          <div class="absolute top-0 right-0 h-12.5 w-12.5 flex items-center justify-center">
            <span class="triangle triangle-md expand-triangle"></span>
          </div>
        </div>
        <div ref="addonsList" class="expand-list">
          <template v-for="(addon, index) in departureAddons">
            <enquiry-booking-addon :addon="addon" :key="index"></enquiry-booking-addon>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateRange, collapseSection, expandSection } from '../src/Helpers.js';
import EnquiryBookingExtra from './EnquiryBookingExtra.vue';
import EnquiryBookingAddon from './EnquiryBookingAddon.vue';
import HandlesAdventures from './Mixins/HandlesAdventures';

export default {
  components: {
    EnquiryBookingExtra,
    EnquiryBookingAddon,
  },

  mixins: [HandlesAdventures],

  props: {
    forceShowDropdowns: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: 'bg-white',
    },
  },

  data() {
    return {
      selectedDepartureId: null,
    };
  },

  computed: {
    loading() {
      return this.$store.state.departure.loading;
    },

    adventureDateString() {
      if (this.selectedDeparture) {
        console.log('runvue');
        return formatDateRange(this.selectedDeparture.start_date, this.selectedDeparture.end_date);
      }
    },
  },

  methods: {
    toggleExtrasList() {
      if (!this.$refs.extrasButton.classList.contains('is-active')) {
        expandSection(this.$refs.extrasList);
        this.$refs.extrasButton.classList.add('is-active');
      } else if (this.$refs.extrasButton.classList.contains('is-active')) {
        collapseSection(this.$refs.extrasList);
        this.$refs.extrasButton.classList.remove('is-active');
      }
    },

    toggleAdventureList() {
      if (!this.$refs.adventuresButton.classList.contains('is-active')) {
        expandSection(this.$refs.adventuresList);
        this.$refs.adventuresButton.classList.add('is-active');
      } else if (this.$refs.adventuresButton.classList.contains('is-active')) {
        collapseSection(this.$refs.adventuresList);
        this.$refs.adventuresButton.classList.remove('is-active');
      }
    },

    onDepartureChange() {
      this.$store.commit('departure/UPDATE_SELECTED_DEPARTURE', this.selectedDepartureId);
    },

    formatDates(start_date, end_date) {
      console.log('run');
      console.log(start_date, end_date);
      return formatDateRange(start_date, end_date);
    },

    toggleAddonsList() {
      if (!this.$refs.addonsButton.classList.contains('is-active')) {
        expandSection(this.$refs.addonsList);
        this.$refs.addonsButton.classList.add('is-active');
      } else if (this.$refs.addonsButton.classList.contains('is-active')) {
        collapseSection(this.$refs.addonsList);
        this.$refs.addonsButton.classList.remove('is-active');
      }
    },

    toggleAddonExtraChecked(event, extra) {
      this.$store.commit('departure/TOGGLE_SELECT_ADDON_EXTRA', extra);
    },

    updateAddonExtraQuantity(event, uuid) {
      this.$store.commit('departure/UPDATE_ADDON_EXTRA_QUANTITY', {
        quantity: parseInt(event.target.value, 10),
        uuid,
      });
    },

    onDepartureQuantityChange() {
      this.$store.commit('departure/UPDATE_SELECTED_DEPARTURE_QUANTITY', this.peopleNumber);
    },
  },

  created() {
    if (this.forceShowDropdowns) {
      this.$nextTick(function() {
        expandSection(this.$refs.adventuresList);
        this.$refs.adventuresButton.classList.add('is-active');
        expandSection(this.$refs.extrasList);
        this.$refs.extrasButton.classList.add('is-active');
        expandSection(this.$refs.addonsList);
        this.$refs.addonsButton.classList.add('is-active');
      });
    }
  },

  watch: {
    selectedDeparture: {
      immediate: true,
      handler(departure) {
        if (!departure) {
          return;
        }

        this.selectedDepartureId = departure.uuid;

        this.$nextTick(function() {
          expandSection(this.$refs.adventuresList);
          this.$refs.adventuresButton.classList.add('is-active');
        });

        if (this.allExtras.length > 0) {
          this.$nextTick(function() {
            expandSection(this.$refs.extrasList);
            this.$refs.extrasButton.classList.add('is-active');
          });
        }

        if (this.departureAddons.length > 0) {
          this.$nextTick(function() {
            expandSection(this.$refs.addonsList);
            this.$refs.addonsButton.classList.add('is-active');
          });
        }
      },
    },
  },
};
</script>
